var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoPermissionArt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 368,
    height: 250,
    viewBox: "0 0 368 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.411,
    y1: 0.932,
    x2: 0.634,
    y2: -0.163,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 143.911,
    y1: 0.5,
    x2: 142.911,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4042e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 89.322,
    y1: 0.5,
    x2: 88.322,
    y2: 0.5,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.262,
    y1: -0.095,
    x2: 0.973,
    y2: 1.387,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.24,
    y1: 0.163,
    x2: -0.694,
    y2: -1.062,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 85.859,
    y1: -0.334,
    x2: 85.158,
    y2: 0.994,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -39.868,
    y1: -4.043,
    x2: -40.278,
    y2: -2.925,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -113.259,
    y1: -5.931,
    x2: -112.131,
    y2: -5.931,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -34.722,
    y1: -5.401,
    x2: -35.963,
    y2: -1.928,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -97.59,
    y1: -6.363,
    x2: -96.689,
    y2: -6.363,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -28.729,
    y1: -2.592,
    x2: -27.735,
    y2: -2.592,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 0.142,
    y1: -0.265,
    x2: 0.904,
    y2: 1.436,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 0.961,
    y1: -2.955,
    x2: 0.675,
    y2: -0.623,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 76.838,
    y1: 66.717,
    x2: 77.296,
    y2: 65.792,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 311.733,
    y1: 229.951,
    x2: 313.618,
    y2: 226.734,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 84.57,
    y1: 65.744,
    x2: 83.83,
    y2: 68.181,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 64.955,
    y1: 0.134,
    x2: 64.555,
    y2: 0.8,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 651.633,
    y1: -0.304,
    x2: 649.794,
    y2: 1.583,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 0.823,
    y1: -0.757,
    x2: 0.354,
    y2: 1.067,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27593",
    "data-name": "Group 27593",
    transform: "translate(-1341 -306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14278",
    "data-name": "Rectangle 14278",
    width: 368,
    height: 250,
    transform: "translate(1341 306)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27592",
    "data-name": "Group 27592",
    transform: "translate(-31.02 20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27588",
    "data-name": "Group 27588",
    transform: "translate(1381 306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8814",
    "data-name": "Path 8814",
    d: "M552.958,259.306c-5.353-5.869-11.684-11.593-13.335-19.561-2.857-13.789,9.359-25.546,13.358-39.013a34.994,34.994,0,0,0-3.773-28.039,31.248,31.248,0,0,0-22.987-14.5c-15.8-1.535-31.267,9.735-46.832,6.472-12.464-2.613-22.313-14.142-34.965-15.377-14.888-1.453-27.241,11.555-41.458,16.452-17.005,5.858-35.443-.264-52.162-6.982s-34.31-14.214-51.933-11c-19.617,3.579-36.065,21.671-38.689,42.556-2.6,20.7,19.207,37.313.644,62.165-5.8,7.766-9.66,18.58-7.1,28.1,2.492,9.251,13.1,15.1,13.172,24.721.061,7.594-6.7,13.636-7.249,21.208-.468,6.5,3.949,12.508,9.376,15.588s11.725,3.833,17.848,4.532l-1.8,2.053c30.841,2.93,61.875,2.278,92.834,1.623l146.469-3.1c5.018-.106,10.157-.237,14.833-2.168s8.869-6.065,9.581-11.323C550,324.769,541.164,317,541.981,308c1.043-11.49,16.33-15.923,19.239-27.049C563.276,273.094,558.311,265.174,552.958,259.306Z",
    transform: "translate(-211.655 -139.562)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27582",
    "data-name": "Group 27582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27452",
    "data-name": "Group 27452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27450",
    "data-name": "Group 27450",
    transform: "translate(0 54.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8568",
    "data-name": "Path 8568",
    d: "M-189.525,5759.934a24.114,24.114,0,0,1,24.9-23.3,24.113,24.113,0,0,1,23.306,24.9v0a25.828,25.828,0,0,0,8.083,19.632,30.676,30.676,0,0,1,9.632,23.384,28.832,28.832,0,0,0,10.509,23.222,34.866,34.866,0,0,1,12.754,28.156,34.928,34.928,0,0,1-36.06,33.754,34.928,34.928,0,0,1-33.753-36.06q.051-1.548.234-3.057a36.025,36.025,0,0,0-8.087-27.358,30.646,30.646,0,0,1-7.1-20.69,30.7,30.7,0,0,1,1.939-9.8,20.192,20.192,0,0,0-2.211-18.445A24,24,0,0,1-189.525,5759.934Z",
    transform: "translate(189.538 -5736.616)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8569",
    "data-name": "Path 8569",
    d: "M-35.7,5973.752a.758.758,0,0,1-.668-.4c-32.732-61.041-41.984-115.25-42.074-115.788a.755.755,0,0,1,.623-.87.755.755,0,0,1,.871.622c.089.538,9.307,54.511,41.914,115.32a.758.758,0,0,1-.309,1.025A.747.747,0,0,1-35.7,5973.752Z",
    transform: "translate(100.551 -5832.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8570",
    "data-name": "Path 8570",
    d: "M-51.326,5890.028a.753.753,0,0,1-.624-.329.756.756,0,0,1,.194-1.052c5.674-3.9,10.279-18.652,10.325-18.8a.756.756,0,0,1,.946-.5.757.757,0,0,1,.5.947c-.193.626-4.807,15.4-10.914,19.6A.774.774,0,0,1-51.326,5890.028Z",
    transform: "translate(79.43 -5842.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8571",
    "data-name": "Path 8571",
    d: "M-116.132,5925.837a.735.735,0,0,1-.282-.054c-.407-.164-10.027-4.068-15.785-10.486a.756.756,0,0,1,.058-1.068.757.757,0,0,1,1.069.056c5.525,6.161,15.125,10.055,15.222,10.094a.758.758,0,0,1,.421.985A.758.758,0,0,1-116.132,5925.837Z",
    transform: "translate(143.762 -5878.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8572",
    "data-name": "Path 8572",
    d: "M3.186,6049.606a.758.758,0,0,1-.526-1.3c8.175-7.912,10.914-22.375,10.94-22.522a.757.757,0,0,1,1.489.273c-.112.612-2.848,15.082-11.376,23.336A.756.756,0,0,1,3.186,6049.606Z",
    transform: "translate(35.762 -5967.757)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8573",
    "data-name": "Path 8573",
    d: "M-84.591,6096.911h-.043c-.459-.025-11.348-.747-22.023-11.705a.757.757,0,0,1,.014-1.07.759.759,0,0,1,1.07.014c10.267,10.539,20.916,11.242,21.022,11.249a.758.758,0,0,1,.714.8A.757.757,0,0,1-84.591,6096.911Z",
    transform: "translate(123.318 -6014.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8574",
    "data-name": "Path 8574",
    d: "M-6.7,6313.4h-.025a40.729,40.729,0,0,1-23.464-9.548.756.756,0,0,1-.067-1.067.757.757,0,0,1,1.068-.067c9.813,8.653,22.387,9.164,22.513,9.169a.757.757,0,0,1,.732.783A.756.756,0,0,1-6.7,6313.4Z",
    transform: "translate(62.098 -6189.945)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8575",
    "data-name": "Path 8575",
    d: "M87.975,6261.973a.757.757,0,0,1-.482-1.341c.083-.069,8.308-7,10.4-21.5a.757.757,0,1,1,1.5.215c-2.177,15.115-10.577,22.16-10.934,22.451A.746.746,0,0,1,87.975,6261.973Z",
    transform: "translate(-32.159 -6138.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27451",
    "data-name": "Group 27451",
    transform: "translate(36.079)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8576",
    "data-name": "Path 8576",
    d: "M49.862,5480.456a30.9,30.9,0,0,0-54.288,29.528l0,0A33.09,33.09,0,0,1-2.4,5537.113a39.31,39.31,0,0,0,2.41,32.316,36.949,36.949,0,0,1,1.312,32.636,44.751,44.751,0,1,0,80.2-3.195q-.947-1.74-2.023-3.364a46.162,46.162,0,0,1-6.463-35.98,39.468,39.468,0,0,0-11.615-37.879,25.868,25.868,0,0,1-8.068-22.393A30.754,30.754,0,0,0,49.862,5480.456Z",
    transform: "translate(8.187 -5464.315)",
    fill: "#9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8577",
    "data-name": "Path 8577",
    d: "M171.2,5773.24h-.021a.757.757,0,0,1-.736-.777c2.395-88.434-18.08-155.555-18.287-156.223a.757.757,0,0,1,1.446-.449c.208.67,20.756,68.032,18.354,156.714A.756.756,0,0,1,171.2,5773.24Z",
    transform: "translate(-120.232 -5585.228)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8578",
    "data-name": "Path 8578",
    d: "M92.014,5692.955a.7.7,0,0,1-.1-.007c-9.336-1.292-23.06-15.511-23.64-16.113a.757.757,0,1,1,1.093-1.048c.138.143,13.939,14.44,22.755,15.66a.758.758,0,0,1-.1,1.508Z",
    transform: "translate(-52.89 -5633.528)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8579",
    "data-name": "Path 8579",
    d: "M188.1,5672.148a.757.757,0,0,1-.567-1.258c.088-.1,8.879-10.127,11.678-20.393a.757.757,0,0,1,1.461.4c-2.893,10.609-11.634,20.576-12,21A.762.762,0,0,1,188.1,5672.148Z",
    transform: "translate(-148.443 -5613.011)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8580",
    "data-name": "Path 8580",
    d: "M118.816,5908.282a.7.7,0,0,1-.227-.034c-14.446-4.529-25.855-19.479-26.334-20.112a.757.757,0,0,1,1.208-.912c.114.152,11.6,15.2,25.579,19.579a.757.757,0,0,1-.226,1.479Z",
    transform: "translate(-72.15 -5802.847)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8581",
    "data-name": "Path 8581",
    d: "M225.291,5886.181a.757.757,0,0,1-.378-1.413c.119-.069,11.994-7.078,17.707-25.085a.757.757,0,0,1,1.443.456c-5.9,18.605-17.89,25.651-18.4,25.941A.745.745,0,0,1,225.291,5886.181Z",
    transform: "translate(-178.235 -5780.604)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8582",
    "data-name": "Path 8582",
    d: "M248.856,6178.872a.758.758,0,0,1-.363-1.422c.142-.079,14.323-7.948,20.608-23.545a.757.757,0,1,1,1.4.564c-6.493,16.118-21.141,24.231-21.288,24.313A.773.773,0,0,1,248.856,6178.872Z",
    transform: "translate(-197.112 -6016.333)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8583",
    "data-name": "Path 8583",
    d: "M146.048,6199.067a.756.756,0,0,1-.167-.02c-.573-.128-14.164-3.35-25.3-19.34a.757.757,0,1,1,1.243-.865,51.186,51.186,0,0,0,16.277,15.234,32.927,32.927,0,0,0,8.112,3.494.758.758,0,0,1-.167,1.5Z",
    transform: "translate(-94.857 -6036.43)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27583",
    "data-name": "Group 27583",
    transform: "translate(240.936 48.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27452-2",
    "data-name": "Group 27452",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27450-2",
    "data-name": "Group 27450",
    transform: "translate(32.287 41.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8568-2",
    "data-name": "Path 8568",
    d: "M-121,5754.532a18.528,18.528,0,0,0-19.131-17.905,18.527,18.527,0,0,0-17.907,19.13v0a19.842,19.842,0,0,1-6.211,15.083,23.571,23.571,0,0,0-7.4,17.968,22.153,22.153,0,0,1-8.074,17.842,26.789,26.789,0,0,0-9.8,21.633,26.835,26.835,0,0,0,27.706,25.935,26.837,26.837,0,0,0,25.934-27.706q-.039-1.189-.179-2.349a27.682,27.682,0,0,1,6.214-21.021,23.542,23.542,0,0,0,5.454-15.9,23.592,23.592,0,0,0-1.49-7.529,15.514,15.514,0,0,1,1.7-14.172A18.44,18.44,0,0,0-121,5754.532Z",
    transform: "translate(189.538 -5736.616)",
    fill: "#396"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8569-2",
    "data-name": "Path 8569",
    d: "M-77.87,5946.632a.583.583,0,0,0,.513-.307c25.149-46.9,32.258-88.55,32.327-88.964a.58.58,0,0,0-.479-.668.58.58,0,0,0-.669.478c-.069.414-7.151,41.883-32.2,88.6a.582.582,0,0,0,.238.788A.579.579,0,0,0-77.87,5946.632Z",
    transform: "translate(96.589 -5838.331)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8570-2",
    "data-name": "Path 8570",
    d: "M-43.343,5885.229a.58.58,0,0,0,.48-.252.583.583,0,0,0-.149-.81c-4.36-3-7.9-14.331-7.933-14.444a.581.581,0,0,0-.727-.386.582.582,0,0,0-.384.728c.149.481,3.693,11.832,8.385,15.062A.59.59,0,0,0-43.343,5885.229Z",
    transform: "translate(90.298 -5849.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8571-2",
    "data-name": "Path 8571",
    d: "M-131.811,5923.1a.565.565,0,0,0,.216-.042c.313-.125,7.7-3.125,12.128-8.057a.581.581,0,0,0-.044-.821.582.582,0,0,0-.821.043c-4.245,4.733-11.621,7.726-11.7,7.755a.583.583,0,0,0-.323.757A.582.582,0,0,0-131.811,5923.1Z",
    transform: "translate(179.13 -5886.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8572-2",
    "data-name": "Path 8572",
    d: "M11.584,6043.944a.582.582,0,0,0,.4-1c-6.281-6.079-8.385-17.192-8.406-17.305a.582.582,0,0,0-1.144.211c.086.47,2.188,11.588,8.741,17.929A.577.577,0,0,0,11.584,6043.944Z",
    transform: "translate(27.038 -5981.057)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8573-2",
    "data-name": "Path 8573",
    d: "M-106.291,6093.9h.033c.352-.019,8.719-.573,16.921-8.993a.582.582,0,0,0-.011-.823.583.583,0,0,0-.822.011c-7.889,8.1-16.071,8.638-16.152,8.643a.583.583,0,0,0-.549.613A.582.582,0,0,0-106.291,6093.9Z",
    transform: "translate(145.083 -6030.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8574-2",
    "data-name": "Path 8574",
    d: "M-29.866,6310.885h.019a31.292,31.292,0,0,0,18.028-7.336.581.581,0,0,0,.052-.82.582.582,0,0,0-.821-.052,30.62,30.62,0,0,1-17.3,7.045.581.581,0,0,0-.562.6A.582.582,0,0,0-29.866,6310.885Z",
    transform: "translate(55.85 -6216.027)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8575-2",
    "data-name": "Path 8575",
    d: "M95.993,6256.532a.581.581,0,0,0,.37-1.03c-.064-.053-6.383-5.377-7.988-16.517a.581.581,0,1,0-1.151.165c1.673,11.614,8.127,17.027,8.4,17.25A.572.572,0,0,0,95.993,6256.532Z",
    transform: "translate(-70.332 -6161.771)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27451-2",
    "data-name": "Group 27451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8576-2",
    "data-name": "Path 8576",
    d: "M20.325,5476.716A23.741,23.741,0,0,1,62.036,5499.4v0a25.424,25.424,0,0,0-1.556,20.842,30.2,30.2,0,0,1-1.852,24.829,28.389,28.389,0,0,0-1.008,25.076A34.384,34.384,0,1,1-4,5567.7q.728-1.337,1.555-2.585a35.467,35.467,0,0,0,4.966-27.645,30.325,30.325,0,0,1,8.924-29.1,19.875,19.875,0,0,0,6.2-17.2A23.631,23.631,0,0,1,20.325,5476.716Z",
    transform: "translate(8.187 -5464.315)",
    fill: "#9c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8577-2",
    "data-name": "Path 8577",
    d: "M152.857,5736.643h.016a.582.582,0,0,0,.566-.6c-1.84-67.947,13.892-119.519,14.051-120.032a.582.582,0,0,0-1.111-.345c-.16.515-15.947,52.271-14.1,120.409A.581.581,0,0,0,152.857,5736.643Z",
    transform: "translate(-118.907 -5592.186)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8578-2",
    "data-name": "Path 8578",
    d: "M68.64,5688.924a.563.563,0,0,0,.081,0c7.173-.994,17.718-11.918,18.163-12.381a.582.582,0,1,0-.84-.805c-.106.109-10.71,11.095-17.483,12.033a.582.582,0,0,0,.079,1.158Z",
    transform: "translate(-25.587 -5643.264)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8579-2",
    "data-name": "Path 8579",
    d: "M197.022,5667a.574.574,0,0,0,.385-.147.58.58,0,0,0,.05-.819c-.068-.077-6.822-7.781-8.972-15.669a.582.582,0,0,0-1.122.308c2.223,8.151,8.939,15.809,9.223,16.131A.584.584,0,0,0,197.022,5667Z",
    transform: "translate(-154.379 -5621.567)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8580-2",
    "data-name": "Path 8580",
    d: "M92.684,5903.334a.539.539,0,0,0,.174-.025c11.1-3.48,19.866-14.966,20.233-15.454a.581.581,0,0,0-.928-.7c-.088.117-8.914,11.676-19.653,15.043a.581.581,0,0,0,.174,1.136Z",
    transform: "translate(-55.426 -5822.324)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8581-2",
    "data-name": "Path 8581",
    d: "M238.984,5879.919a.581.581,0,0,0,.29-1.085c-.092-.054-9.215-5.438-13.605-19.274a.581.581,0,0,0-1.109.351c4.535,14.295,13.745,19.709,14.135,19.932A.564.564,0,0,0,238.984,5879.919Z",
    transform: "translate(-202.026 -5798.801)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8582-2",
    "data-name": "Path 8582",
    d: "M264.775,6172.979a.582.582,0,0,0,.279-1.093c-.109-.062-11.005-6.107-15.834-18.092a.581.581,0,0,0-1.079.434c4.989,12.384,16.243,18.618,16.357,18.681A.59.59,0,0,0,264.775,6172.979Z",
    transform: "translate(-231.419 -6048.094)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8583-2",
    "data-name": "Path 8583",
    d: "M121.029,6194.307a.58.58,0,0,0,.128-.015c.44-.1,10.883-2.573,19.437-14.859a.582.582,0,0,0-.955-.666,39.315,39.315,0,0,1-12.506,11.706,25.331,25.331,0,0,1-6.232,2.685.582.582,0,0,0,.128,1.15Z",
    transform: "translate(-87.248 -6069.347)",
    fill: "url(#linear-gradient-8)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27554",
    "data-name": "Group 27554",
    transform: "translate(43.585 139.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8826",
    "data-name": "Path 8826",
    d: "M268.209,1014.757s23.565,8.893,60.6,64.212C328.808,1078.969,288.644,1025.345,268.209,1014.757Z",
    transform: "translate(-268.209 -1014.757)",
    fill: "#fff",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27557",
    "data-name": "Group 27557",
    transform: "translate(63.952 65.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27556",
    "data-name": "Group 27556",
    transform: "translate(11.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8827",
    "data-name": "Path 8827",
    d: "M703.016,663.324a4,4,0,0,1-3.993,3.989H483.095a4,4,0,0,1-3.993-3.989l-1.8-124.088a6.954,6.954,0,0,1,7.322-6.156l211.029-5.46a10.062,10.062,0,0,1,10.325,10.292Z",
    transform: "translate(-477.305 -527.617)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8828",
    "data-name": "Path 8828",
    d: "M729.975,685.968a3.789,3.789,0,0,1-3.778,3.778H519.2a3.789,3.789,0,0,1-3.778-3.778l-1.7-112.648c.2-6.779,6.143-9.215,9.746-9.071l202.252-5.426a7.072,7.072,0,0,1,7.255,7.237Z",
    transform: "translate(-508.206 -554.087)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27555",
    "data-name": "Group 27555",
    transform: "translate(8.309 10.825)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8829",
    "data-name": "Path 8829",
    d: "M537.2,988.2a.305.305,0,0,1-.305-.3l-.134-9.135a.305.305,0,0,1,.3-.31h0a.305.305,0,0,1,.3.3l.134,9.135a.305.305,0,0,1-.3.31Z",
    transform: "translate(-536.056 -920.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8830",
    "data-name": "Path 8830",
    d: "M532.913,643.9a.305.305,0,0,1-.3-.3l-.514-34.989a7.407,7.407,0,0,1,2.14-5.554c2.564-2.457,6.576-2.334,6.745-2.327L605.567,599a.3.3,0,0,1,.313.3.3.3,0,0,1-.3.313l-64.606,1.733c-.18-.006-3.943-.123-6.322,2.157a6.816,6.816,0,0,0-1.952,5.11l.514,34.984a.306.306,0,0,1-.3.31Z",
    transform: "translate(-532.094 -598.996)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8831",
    "data-name": "Path 8831",
    d: "M582.714,727.068c.217-9.311.136-91.758-.4-98.878s10.556-8.456,27.581-9.257,160.682-3.974,164.38-4.274c8.314-.674,10.035,11.753,9.2,38.731-.625,20.268-1.661,53.657-2.137,69.012a8.473,8.473,0,0,1-8.453,8.212c-34.569.095-167.064.475-175.884.737C586.857,731.653,582.628,730.76,582.714,727.068Z",
    transform: "translate(-566.375 -601.437)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8918",
    "data-name": "Path 8918",
    d: "M2.407,0H252.164a2.407,2.407,0,0,1,2.407,2.407V8.5a2.407,2.407,0,0,1-2.407,2.407H2.407A2.407,2.407,0,0,1,0,8.5V2.407A2.407,2.407,0,0,1,2.407,0Z",
    transform: "translate(0 135.127)",
    fill: "#0c1b24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27563",
    "data-name": "Group 27563",
    transform: "translate(31.672 57.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8832",
    "data-name": "Path 8832",
    d: "M194.859,728.21l99.3-1.678a6.959,6.959,0,0,1,6.969,7.447l-3.418,58.778a6.054,6.054,0,0,1-5.922,5.768l-95.45.944a4.4,4.4,0,0,1-4.4-4.289l-2.284-61.346A5.365,5.365,0,0,1,194.859,728.21Z",
    transform: "translate(-189.653 -726.531)",
    fill: "#14097d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8833",
    "data-name": "Path 8833",
    d: "M200.59,743.891a5.155,5.155,0,0,1,5.066-5.35l96.707-1.6a6.689,6.689,0,0,1,6.787,7.085l-3.329,55.921a5.835,5.835,0,0,1-5.768,5.488l-92.959.9a4.243,4.243,0,0,1-4.281-4.081Z",
    transform: "translate(-198.928 -735.364)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8834",
    "data-name": "Path 8834",
    d: "M214.112,756.772a4.909,4.909,0,0,1,4.824-5.095l92.088-1.52a6.369,6.369,0,0,1,6.463,6.747l-3.17,53.25a5.556,5.556,0,0,1-5.492,5.225l-88.519.855a4.04,4.04,0,0,1-4.076-3.886Z",
    transform: "translate(-210.399 -746.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8835",
    "data-name": "Path 8835",
    d: "M301.45,736.639l-97.112,1.6a5.176,5.176,0,0,0-5.087,5.373l.157,4.114H308.029l.237-3.975A6.716,6.716,0,0,0,301.45,736.639Z",
    transform: "translate(-197.792 -735.105)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27558",
    "data-name": "Group 27558",
    transform: "translate(7.853 4.252)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8836",
    "data-name": "Path 8836",
    d: "M243.182,755.442a.873.873,0,1,1-.874-.874A.873.873,0,0,1,243.182,755.442Z",
    transform: "translate(-241.435 -754.569)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8837",
    "data-name": "Path 8837",
    d: "M243.182,772.319a.873.873,0,1,1-.874-.873A.874.874,0,0,1,243.182,772.319Z",
    transform: "translate(-241.435 -768.887)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8838",
    "data-name": "Path 8838",
    d: "M243.182,789.2a.873.873,0,1,1-.874-.873A.873.873,0,0,1,243.182,789.2Z",
    transform: "translate(-241.435 -783.203)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27570",
    "data-name": "Group 27570",
    transform: "translate(45.291 85.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8874",
    "data-name": "Path 8874",
    d: "M1733.357,937.783s-2.435,1.185-2.883,2.545c-.359,1.092-3.053,1.233-3.319,3.38a2.464,2.464,0,0,1-2.062,2.166c-2.751.422-6.99,1.85-7.668,6.626-.518,3.645,1.34,5.027,3.291,5.506a2.762,2.762,0,0,1,2.094,3.191c-.278,1.387.137,2.99,2.539,4.258,5.385,2.841,10.762-6.731,10.762-6.731l1.1-16.714Z",
    transform: "translate(-1705.105 -921.421)",
    fill: "#150e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8875",
    "data-name": "Path 8875",
    d: "M1621.212,893.049s-6.929,18.888-18.735,24.792c0,0,3.93,6.411,5.98,6.8,0,0,12.612-16.142,13.9-29.367Z",
    transform: "translate(-1567.613 -885.502)",
    fill: "#f5adab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8876",
    "data-name": "Path 8876",
    d: "M1855.321,1465.194l-.349,2.865a1.183,1.183,0,0,1-1.038,1.035,18.3,18.3,0,0,1-3.833.06,1.013,1.013,0,0,1-.851-1.314,10.423,10.423,0,0,1,1.922-3.742h3.177A.979.979,0,0,1,1855.321,1465.194Z",
    transform: "translate(-1849.202 -1344.028)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8877",
    "data-name": "Path 8877",
    d: "M1716.945,1299.368l.536,3.155s-1.8,18.193-2.116,25.47a5.7,5.7,0,0,0,.844,3.241l3.123,5.072-7.937-4.684-.158-.968,1.3-1.787-1.7-20.38a6.253,6.253,0,0,1,.712-3.458l1.642-3.084Z",
    transform: "translate(-1685.938 -1211.758)",
    fill: "#feb3b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8878",
    "data-name": "Path 8878",
    d: "M1714,1459.866h-2.533a1.525,1.525,0,0,1-1.21-.593c-.79-1.026-2.426-3.028-3.208-3.08-1.053-.071-.918,3.673-.918,3.673h-.591l-.748-4.652a2.755,2.755,0,0,1,1.445-2.879h0a3.894,3.894,0,0,0,1.546,2.568c1.306.788,5.312,3.607,5.312,3.607a3.629,3.629,0,0,1,1.029.027A.67.67,0,0,1,1714,1459.866Z",
    transform: "translate(-1680.086 -1334.583)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8879",
    "data-name": "Path 8879",
    d: "M1797.127,1301.63s-10.522,19.959-12.194,24.516a43.748,43.748,0,0,0-2.281,8.719c-.035.563-.735,1.1-2.663,1.1a1.85,1.85,0,0,1-1.721-.785,1.125,1.125,0,0,1-.043-1.089c.609-1.232,2.54-5.168,3.256-6.954.854-2.131,2.691-11.792,3.7-15.151s2.146-7,6.534-10.358C1791.713,1301.63,1794.725,1298.68,1797.127,1301.63Z",
    transform: "translate(-1776.992 -1212.521)",
    fill: "#feb3b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8880",
    "data-name": "Path 8880",
    d: "M1673.4,1042.932c2.715-11.5-4.162-18.006-4.162-18.006,4.338-4.164,12.244-6.06,12.244-6.06s7.543,5.515,6.648,9.831c-.525,2.53-5.3,15.153-5.3,15.153A10.5,10.5,0,0,1,1673.4,1042.932Z",
    transform: "translate(-1646.622 -986.527)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8881",
    "data-name": "Path 8881",
    d: "M1700.123,1146.693c1.1-3.328,6.018-5.694,6.018-5.694a10.5,10.5,0,0,0,9.428.919,18.909,18.909,0,0,1,.307,7.306c-.684,3.519-4.974,26.136-4.974,26.136-6.76,1.37-17.156-1.378-17.156-1.378C1698.051,1166.337,1699.018,1150.021,1700.123,1146.693Z",
    transform: "translate(-1679.358 -1084.594)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8882",
    "data-name": "Path 8882",
    d: "M1708.979,976.443l-2.206,9.912c-.212.873.584.73,1.467.564,1.446-.273,3.309-.834,3.932-1.959a1.063,1.063,0,0,0,.113-.373l.948-6.873a1.235,1.235,0,0,0-.723-1.3l-1.83-.811A1.235,1.235,0,0,0,1708.979,976.443Z",
    transform: "translate(-1679.046 -951.705)",
    fill: "#f5adab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8883",
    "data-name": "Path 8883",
    d: "M1755.032,1049.619s-15.4,11.019-1.97,22.6a3.471,3.471,0,0,0,1.52.88,16.737,16.737,0,0,1,2.776,1.884.523.523,0,0,0,.764-.137h0a.714.714,0,0,0,.04-.684l-1.906-4.032a1.471,1.471,0,0,0-1.91-.083h0a.726.726,0,0,1-1.1-.249c-1.038-2.115-3-8.334,5.026-15.363a.869.869,0,0,0,.193-1.057C1757.9,1052.293,1756.611,1050.142,1755.032,1049.619Z",
    transform: "translate(-1732.411 -1011.22)",
    fill: "#f5adab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27568",
    "data-name": "Group 27568",
    transform: "translate(24.991 11.778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8884",
    "data-name": "Path 8884",
    d: "M1693.326,931.762a9.778,9.778,0,0,1,4.39,4.88c1.778,3.777.45,5.52-1.216,5.76a7.8,7.8,0,0,1-6.8-2.237C1687.067,937.726,1689.929,930.454,1693.326,931.762Z",
    transform: "translate(-1685.796 -928.24)",
    fill: "#f5adab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8885",
    "data-name": "Path 8885",
    d: "M1706.857,924.432s-1.971-5.525,2.927-5.591l1.153.806s1.8-3.063-1.153-4.526-6.4-.255-7.659,3.72-1.47,6.635.619,8.537,2.949-.255,2.949-.255-1.137-1.778-.674-2.73,1.531.2,1.531.2Z",
    transform: "translate(-1701.177 -914.523)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8886",
    "data-name": "Path 8886",
    d: "M1730.139,959.869s-1-2.846-2.327-1.713,1.081,2.629,2.025,3.113Z",
    transform: "translate(-1725.008 -949.344)",
    fill: "#f5adab"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27569",
    "data-name": "Group 27569",
    transform: "translate(52.221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8887",
    "data-name": "Path 8887",
    d: "M1583.451,865.732c.106.336-1.118.848-1.839-.527-.025-.659-.426-3.481-.032-4.017a52.581,52.581,0,0,1,6.161-6.441.967.967,0,0,1,.121,1.344l-1.972,2.054a9.537,9.537,0,0,1,1.152,2.276,2.763,2.763,0,0,1-.276,2.034c-.346.624-.818,1.434-1.265,2.068A2.728,2.728,0,0,1,1583.451,865.732Z",
    transform: "translate(-1581.407 -854.747)",
    fill: "#f5adab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8888",
    "data-name": "Path 8888",
    d: "M1595.861,882.641a19.253,19.253,0,0,1,.913-3.592,1.163,1.163,0,0,0,.219-.916.85.85,0,0,0-.478-.521l-.118-.06-1.937,1.642-.582,1.565.372.138.546-1.468,1.65-1.4a.393.393,0,0,1,.166.209.829.829,0,0,1-.176.6,20.185,20.185,0,0,0-.965,3.729Z",
    transform: "translate(-1592.805 -873.059)",
    fill: "#f5adab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27579",
    "data-name": "Group 27579",
    transform: "translate(240.936 116.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27573",
    "data-name": "Group 27573",
    transform: "translate(43.59 58.327)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27571",
    "data-name": "Group 27571",
    transform: "translate(13.193 6.574)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14276",
    "data-name": "Rectangle 14276",
    width: 2.553,
    height: 28.777,
    fill: "#7d97f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27572",
    "data-name": "Group 27572",
    transform: "translate(3.289 34.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8889",
    "data-name": "Path 8889",
    d: "M1990.252,1483.937h-22.36v-1.14a.592.592,0,0,1,.592-.593h21.129a.638.638,0,0,1,.639.638Z",
    transform: "translate(-1967.892 -1482.205)",
    fill: "#7d97f4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_14277",
    "data-name": "Rectangle 14277",
    d: "M4.237,0h21.4a4.237,4.237,0,0,1,4.237,4.237v0a4.237,4.237,0,0,1-4.237,4.237H4.237A4.237,4.237,0,0,1,0,4.237v0A4.237,4.237,0,0,1,4.237,0Z",
    fill: "#7d97f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27575",
    "data-name": "Group 27575",
    transform: "translate(20.232 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8890",
    "data-name": "Path 8890",
    d: "M1882.911,1439.349s-8.253,3.555-7.78,7.275c0,0,8.531-1.636,10.058-4.075s.685-3.851.685-3.851Z",
    transform: "translate(-1867.714 -1355.225)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8891",
    "data-name": "Path 8891",
    d: "M1908.879,1422.253l.419,3.622a1.2,1.2,0,0,1-.758,1.273,3.125,3.125,0,0,1-1.046.159,1.4,1.4,0,0,1-1.355-1.017l-.812-2.93Z",
    transform: "translate(-1891.661 -1342.191)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8892",
    "data-name": "Path 8892",
    d: "M1910.053,1288.221s-15.18-.7-22.734,3.7.383,25.547.383,25.547a7.669,7.669,0,0,0,4.814-1.094s-4.055-15.477,2.988-18.169a40.546,40.546,0,0,1,16.108-2.291l-1.517-7.217Z",
    transform: "translate(-1874.806 -1235.936)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8893",
    "data-name": "Path 8893",
    d: "M1871.526,1459.592c1.726-.378,6.845-2.5,7.622-2.471s1.879,1.193,1.879,1.193a2.07,2.07,0,0,1-.366,1.551,14.332,14.332,0,0,1-7.463,3.124,5.543,5.543,0,0,1-4.728-1.752A6.753,6.753,0,0,1,1871.526,1459.592Z",
    transform: "translate(-1862.451 -1369.825)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8894",
    "data-name": "Path 8894",
    d: "M1870.377,1473.471a14.331,14.331,0,0,0,7.463-3.123,6.446,6.446,0,0,1-2.437,2.122c-3.338,1.886-8.855,1.611-9.948,1.186-.876-.34-.605-1.158.2-1.938A5.542,5.542,0,0,0,1870.377,1473.471Z",
    transform: "translate(-1859.63 -1380.307)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8895",
    "data-name": "Path 8895",
    d: "M1919.878,1446.332a12.3,12.3,0,0,1-2.021,2.428,1.377,1.377,0,0,1-1.279.385,3.543,3.543,0,0,1-.915-.321.893.893,0,0,1-.345-1.215l1.768-3.214Z",
    transform: "translate(-1899.489 -1359.738)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8896",
    "data-name": "Path 8896",
    d: "M1952.176,1282.241s1.325,9.4-2.506,11.322-12.234,3.179-15.129,8.055-8.092,14.445-12.823,17.194c0,0-2.7-.879-3.491-2.207,0,0,5.615-14.761,7.958-18.349,2.028-3.107,5-7.583,9.209-9.519,1.206-.554,1.3-1.834,1.089-3.145l-.387-2.386Z",
    transform: "translate(-1901.884 -1231.229)",
    fill: "#66f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8897",
    "data-name": "Path 8897",
    d: "M1906.38,1177.6c5.371,1.533,7.775-13.583,7.754-13.951l8.235,9.629s-4.907,8.635-12.316,9.553a8.745,8.745,0,0,1-4.807-.7A7.7,7.7,0,0,0,1906.38,1177.6Z",
    transform: "translate(-1891.597 -1137.24)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8898",
    "data-name": "Path 8898",
    d: "M1844.3,1206.006a4.311,4.311,0,0,1,4.327.958c2.32,2.374,4.159,3.573,5.62,3.99a7.7,7.7,0,0,1-1.134,4.526,11.978,11.978,0,0,1-5.276-5.343,1,1,0,0,0-1.325-.449c-.5.24-1.008.606-1.04,1.1-.063.981-1.23,1.039-1.237.676a14.54,14.54,0,0,1,.9-2.3s-2.69,1.725-3.737,2.385a1.542,1.542,0,0,1-1.939-.429S1841.956,1206.968,1844.3,1206.006Z",
    transform: "translate(-1839.46 -1170.598)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8899",
    "data-name": "Path 8899",
    d: "M1973.219,1128.479s-7.218-4.924-24.651,3.981a5.674,5.674,0,0,0-.954,4.842c.841,2.566,11.191,16.45,11.594,22.968,0,0,7.075,4.165,16.26.036C1975.468,1160.306,1978.548,1143.095,1973.219,1128.479Z",
    transform: "translate(-1924.997 -1108.294)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8900",
    "data-name": "Path 8900",
    d: "M1977.724,1103.323l2.852,5.589a1.589,1.589,0,0,1-.164,1.714,4.54,4.54,0,0,1-5.224,1.454,2.452,2.452,0,0,1-1.67-1.778l-1.478-6.239Z",
    transform: "translate(-1944.531 -1089.433)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8901",
    "data-name": "Path 8901",
    d: "M2065.211,1153.184c.489-3.4-8.489-9.983-8.489-9.983l3.145-9.535s17.132,12.226,13.529,22.211a6.974,6.974,0,0,1-2.226,3.213A11.158,11.158,0,0,0,2065.211,1153.184Z",
    transform: "translate(-2011.644 -1113.481)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8902",
    "data-name": "Path 8902",
    d: "M2008.187,1228.678s10.156,2.837,12.263-.255a1.614,1.614,0,0,0,.262-.688,11.157,11.157,0,0,1,5.958,5.906c-4.822,3.794-14.12-.459-16.646-1.734a1.784,1.784,0,0,0-1.338-.112,12.192,12.192,0,0,1-3.323.668c-1.269-.07-2.632,4.517-4.791,3.356C2000.573,1235.819,2001.555,1227.984,2008.187,1228.678Z",
    transform: "translate(-1967.145 -1188.032)",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27574",
    "data-name": "Group 27574",
    transform: "translate(23.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8903",
    "data-name": "Path 8903",
    d: "M1957.109,1061.575s-2.659,4.42-3.12,6.863-1.2,3.97,1.578,4.841a6.1,6.1,0,0,0,6.986-2.512s2.532-3.509,2.28-5.117S1957.109,1061.575,1957.109,1061.575Z",
    transform: "translate(-1953.541 -1056.348)",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8904",
    "data-name": "Path 8904",
    d: "M1966.278,1048.909l-.359-.047s1.883-2.845.651-3.551-6.252-2.438-7.124-4.415a3.433,3.433,0,0,1,1.933-4.509.193.193,0,0,1,.232.122l.089.24a.2.2,0,0,0,.361.01h0a.194.194,0,0,1,.353-.007c.269.593,1.074,1.6,3.488,2.387,3.426,1.11,5.56,2.837,5.3,5.271a.2.2,0,0,0,.278.2c.28-.124.7-.143,1.2.4.858.938.186,2.989-2.155,4.44a.194.194,0,0,0-.032.311c.35.3.843.969-.741,1.565a3.981,3.981,0,0,1-2.832.272.2.2,0,0,1-.12-.219l.416-2.133a.2.2,0,0,0-.166-.231Z",
    transform: "translate(-1958.006 -1036.38)",
    fill: "#09005d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8905",
    "data-name": "Path 8905",
    d: "M1992.7,1090.884s1.173-2.892,2.405-1.876-1.139,3.264-2.233,3.234Z",
    transform: "translate(-1984.573 -1077.917)",
    fill: "url(#linear-gradient-32)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27576",
    "data-name": "Group 27576",
    transform: "translate(1.615 25.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8906",
    "data-name": "Path 8906",
    d: "M1879.876,1255.238h-.055l-23.727-.026a1.062,1.062,0,0,1,0-2.124l23.727.026a1.062,1.062,0,0,1,.052,2.123Z",
    transform: "translate(-1833.186 -1233.695)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8907",
    "data-name": "Path 8907",
    d: "M1751.312,1159.617h19.76a3.766,3.766,0,0,1,3.406,2.16l9.135,19.37h-24.556a2.288,2.288,0,0,1-2.128-1.448l-7.084-17.924A1.578,1.578,0,0,1,1751.312,1159.617Z",
    transform: "translate(-1749.732 -1159.617)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8908",
    "data-name": "Path 8908",
    d: "M1812.391,1199.925c.428,1.33.112,2.622-.707,2.886s-1.829-.6-2.257-1.932-.112-2.622.707-2.886S1811.962,1198.594,1812.391,1199.925Z",
    transform: "translate(-1796.89 -1189.993)",
    fill: "url(#linear-gradient-35)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27578",
    "data-name": "Group 27578",
    transform: "translate(0 46.886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27577",
    "data-name": "Group 27577",
    transform: "translate(5.401 2.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8909",
    "data-name": "Path 8909",
    d: "M1768.978,1318.032a1.1,1.1,0,0,1-.393-.073.857.857,0,0,1-.522-1.169l20.911-43.386a1.046,1.046,0,0,1,1.31-.466.856.856,0,0,1,.522,1.169l-20.911,43.386A1.008,1.008,0,0,1,1768.978,1318.032Z",
    transform: "translate(-1767.981 -1272.865)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8910",
    "data-name": "Path 8910",
    d: "M1802.638,1318.031a1.008,1.008,0,0,1-.917-.539l-20.911-43.386a.857.857,0,0,1,.522-1.169,1.046,1.046,0,0,1,1.31.466l20.911,43.386a.857.857,0,0,1-.522,1.169A1.105,1.105,0,0,1,1802.638,1318.031Z",
    transform: "translate(-1778.084 -1272.865)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8911",
    "data-name": "Path 8911",
    d: "M2080.949,1318.032a1.107,1.107,0,0,1-.394-.073.857.857,0,0,1-.521-1.169l20.911-43.386a1.046,1.046,0,0,1,1.31-.466.857.857,0,0,1,.522,1.169l-20.911,43.386A1.009,1.009,0,0,1,2080.949,1318.032Z",
    transform: "translate(-2015.224 -1272.865)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8912",
    "data-name": "Path 8912",
    d: "M2114.609,1318.031a1.007,1.007,0,0,1-.916-.539l-20.912-43.386a.857.857,0,0,1,.522-1.169,1.046,1.046,0,0,1,1.31.466l20.911,43.386a.857.857,0,0,1-.522,1.169A1.1,1.1,0,0,1,2114.609,1318.031Z",
    transform: "translate(-2025.327 -1272.865)",
    fill: "#7d97f4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8913",
    "data-name": "Path 8913",
    d: "M1839.085,1263.645a1.2,1.2,0,0,0-.2-.894.9.9,0,0,0-.726-.393h-95.13a1.057,1.057,0,0,0-.912.574,1.408,1.408,0,0,0-.071,1.193l1.031,2.566a1.445,1.445,0,0,0,1.31.964h93.119a1.145,1.145,0,0,0,1.073-1.018Z",
    transform: "translate(-1741.949 -1262.358)",
    fill: "#bdd0fb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27580",
    "data-name": "Group 27580",
    transform: "translate(215.807 44.877)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8914",
    "data-name": "Path 8914",
    d: "M1621.9,315.96l-49.716-.277a2.61,2.61,0,0,0-2.252,3.953l.25.416a2.61,2.61,0,0,0,2.238,1.266h49.466a2.61,2.61,0,0,0,2.61-2.61v-.139A2.61,2.61,0,0,0,1621.9,315.96Z",
    transform: "translate(-1569.558 -315.683)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8915",
    "data-name": "Path 8915",
    d: "M1960.516,320.5v.081a2.61,2.61,0,0,0,2.609,2.61h11.036a2.609,2.609,0,0,0,2.521-1.936h0a2.609,2.609,0,0,0-2.5-3.283l-11.037-.081A2.61,2.61,0,0,0,1960.516,320.5Z",
    transform: "translate(-1901.227 -317.556)",
    fill: "#d8d8d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27581",
    "data-name": "Group 27581",
    transform: "translate(215.807 54.244)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8916",
    "data-name": "Path 8916",
    d: "M1609.943,377.731l-37.757-.277a2.61,2.61,0,0,0-2.252,3.953l.25.416a2.61,2.61,0,0,0,2.238,1.266h37.507a2.609,2.609,0,0,0,2.61-2.61v-.139A2.609,2.609,0,0,0,1609.943,377.731Z",
    transform: "translate(-1569.558 -377.454)",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8917",
    "data-name": "Path 8917",
    d: "M1881.656,382.271v.081a2.61,2.61,0,0,0,2.61,2.61H1895.3a2.61,2.61,0,0,0,2.521-1.936h0a2.61,2.61,0,0,0-2.5-3.283l-11.036-.081A2.61,2.61,0,0,0,1881.656,382.271Z",
    transform: "translate(-1834.326 -379.327)",
    fill: "#d8d8d8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27591",
    "data-name": "Group 27591",
    transform: "translate(1512.14 389.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27524",
    "data-name": "Group 27524"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1699",
    "data-name": "Ellipse 1699",
    cx: 39.699,
    cy: 39.699,
    r: 39.699,
    transform: "translate(0 56.143) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1700",
    "data-name": "Ellipse 1700",
    cx: 38.379,
    cy: 38.379,
    r: 38.379,
    transform: "translate(1.867 56.143) rotate(-45)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8782",
    "data-name": "Path 8782",
    d: "M868.068,585.813a.406.406,0,0,0,.361-.589,35.684,35.684,0,0,0-32.008-19.708,36.141,36.141,0,0,0-6.464.582.405.405,0,0,0,.146.8,35.345,35.345,0,0,1,6.319-.568,34.877,34.877,0,0,1,31.285,19.262A.405.405,0,0,0,868.068,585.813Z",
    transform: "translate(-780.279 -545.207)",
    fill: "#fff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1701",
    "data-name": "Ellipse 1701",
    cx: 32.483,
    cy: 32.483,
    r: 32.483,
    transform: "translate(9.369 56.979) rotate(-45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27589",
    "data-name": "Group 27589",
    transform: "matrix(0.951, 0.309, -0.309, 0.951, 37.21, 41.235)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8919",
    "data-name": "Path 8919",
    d: "M18.354,14.291l-6.49,6.491C8.141,24.5,1.747,19.263,4.258,14.848A13.128,13.128,0,0,1,6.5,12.513l4.365-4.365C13.2,5.815,16.344,1.442,19.89,4.625c1.691,1.518,4.2-.976,2.5-2.5a7.64,7.64,0,0,0-9.178-1.055c-1.484.845-2.741,2.468-3.928,3.655q-2.77,2.771-5.543,5.542A11.9,11.9,0,0,0,.3,15.142c-1.92,6.048,5.753,12.486,11.368,10.036,2.005-.875,3.452-2.65,4.971-4.17l4.216-4.216a1.77,1.77,0,0,0-2.5-2.5Z",
    transform: "translate(0 0)",
    fill: "#e8605a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27590",
    "data-name": "Group 27590",
    transform: "matrix(0.545, 0.839, -0.839, 0.545, 70.517, 39.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8920",
    "data-name": "Path 8920",
    d: "M4.6,11.421l6.491-6.49c3.722-3.722,10.116,1.517,7.6,5.932a13.127,13.127,0,0,1-2.24,2.335l-4.364,4.365C9.76,19.9,6.612,24.27,3.067,21.087c-1.69-1.518-4.2.975-2.5,2.5a7.642,7.642,0,0,0,9.178,1.055c1.484-.845,2.742-2.467,3.929-3.655l5.542-5.542a11.908,11.908,0,0,0,3.442-4.877C24.576,4.522,16.9-1.916,11.289.534,9.283,1.409,7.836,3.184,6.317,4.7L2.1,8.919a1.77,1.77,0,0,0,2.5,2.5Z",
    transform: "translate(0 0)",
    fill: "#fe7f75"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPermissionArt);
export default __webpack_public_path__ + "static/media/no-permission_art.147d1dc7d1fa5fc0213ba72a3898d3f0.svg";
export { ForwardRef as ReactComponent };